import React, { useState } from "react";

import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { ResultsSidePanel } from "./ResultsSidePanel";

export const ConnectedResultsSidePanel: React.FC = () => {
  const [sidePanelOpen, setSidePanelOpen] = useState(false);
  const { deviceTesterState } = useDeviceTesterStateContext();

  const closeSidePanel = () => {
    setSidePanelOpen(false);
  };

  const openSidePanel = () => {
    setSidePanelOpen(true);
  };

  return (
    <ResultsSidePanel
      isSidePanelOpen={sidePanelOpen}
      openSidePanel={openSidePanel}
      closeSidePanel={closeSidePanel}
      isInfoFetched={deviceTesterState.isInfoFetched}
    />
  );
};
